// Predefined dietary / allergen tags. Must match DIETARY_TAGS in
// backend/app/schemas/menu.py -- the server validates against this set
// and silently drops unknown slugs.
export const DIETARY_TAG_OPTIONS = [
  { slug: "vegan",            label: "Vegan",            color: "#1b6b1e" },
  { slug: "vegetarian",       label: "Vegetarian",       color: "#3a8a3d" },
  { slug: "fasting",          label: "Fasting (የጾም)",     color: "#5a7a3d" },
  { slug: "gluten_free",      label: "Gluten-free",      color: "#a6611a" },
  { slug: "dairy_free",       label: "Dairy-free",       color: "#5a4fcf" },
  { slug: "nut_free",         label: "Nut-free",         color: "#8a5a00" },
  { slug: "halal",            label: "Halal",            color: "#1a7a6b" },
  { slug: "kosher",           label: "Kosher",           color: "#3a6db8" },
  { slug: "spicy",            label: "Spicy 🌶",          color: "#b13c38" },
  { slug: "contains_alcohol", label: "Contains alcohol", color: "#6b3a8a" },
];
